export function Heading({ first, second }: { first: string; second: string }) {
  return (
    <h1 className="inline-block font-bold text-2xl text-primary sm:text-3xl md:text-4xl">
      {first}{' '}
      <span className="bg-primary px-2 py-1 text-background">{second}</span>
    </h1>
  );
}
